import "core-js/modules/es.array.map";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Menu from '@material-ui/core/Menu';
import useRedirect from '@sprinx/react-routes/useRedirect';
var useStyles = makeStyles(function (theme) {
  return {
    root: function root(_ref) {
      var bgColor = _ref.bgColor;
      return {
        backgroundColor: bgColor || theme.palette.grey[200],
        height: 24,
        color: theme.palette.getContrastText(bgColor || theme.palette.grey[200]),
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
          boxShadow: theme.shadows[2],
          backgroundColor: emphasize(bgColor || theme.palette.grey[200], 0.12)
        },
        '&:active': {
          boxShadow: theme.shadows[1],
          backgroundColor: emphasize(bgColor || theme.palette.grey[200], 0.24)
        }
      };
    },
    icon: {
      background: 'none',
      marginRight: -theme.spacing(1.5)
    }
  };
});

var _ref3 = React.createElement(ExpandMoreIcon, null);

function PageBreadcrumbsItem(_ref2) {
  var bgColor = _ref2.bgColor,
      children = _ref2.children,
      pClasses = _ref2.classes,
      icon = _ref2.icon,
      onClick = _ref2.onClick,
      to = _ref2.to,
      rest = _objectWithoutProperties(_ref2, ["bgColor", "children", "classes", "icon", "onClick", "to"]);

  var chipRef = React.useRef();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  var classes = useStyles({
    classes: pClasses,
    bgColor: bgColor
  }, {
    name: 'SxPageBreadcrumbsItem'
  });
  var setRedirect = useRedirect();

  var handleToggle = function handleToggle() {
    setExpanded(function (p) {
      return !p;
    });
  };

  var clickHandler = React.useMemo(function () {
    return to ? function () {
      return setRedirect(to);
    } : onClick;
  }, [onClick, setRedirect, to]);
  var additionalProps = React.useMemo(function () {
    return {
      avatar: icon ? React.createElement(Avatar, {
        className: classes.icon
      }, icon) : undefined,
      deleteIcon: children ? _ref3 : undefined,
      onDelete: children ? handleToggle : undefined,
      onClick: children ? handleToggle : clickHandler
    };
  }, [children, classes.icon, clickHandler, icon]); // deleteIcon === pokial su childreny

  return React.createElement(React.Fragment, null, React.createElement(Chip, _extends({}, rest, additionalProps, {
    ref: chipRef,
    classes: classes
  })), children && React.createElement(Menu, {
    anchorEl: chipRef.current,
    autoFocus: true,
    onClose: function onClose() {
      return handleToggle();
    },
    open: expanded
  }, React.Children.map(children, function (ch) {
    return React.cloneElement(ch, {
      dense: true
    });
  })));
}

PageBreadcrumbsItem.propTypes = {
  bgColor: PropTypes.string,

  /**
   * Pole MenuItem. Pokud je definovano, po kliku se zobrazi menu.
   */
  children: PropTypes.node,
  classes: PropTypes.shape({
    icon: PropTypes.string,
    root: PropTypes.string
  }),
  icon: PropTypes.element,
  label: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string
};
PageBreadcrumbsItem.defaultProps = {
  bgColor: undefined,
  children: null,
  classes: undefined,
  icon: undefined,
  onClick: undefined,
  to: undefined
};
export default PageBreadcrumbsItem;